import {
  PRINT_WITH_PRICE_DISCOUNT,
  PRINT_WITH_PRICE_ONLY,
  PRINT_WITH_NO_PRICE
} from '../constants';

export const pushEventInfo = (analyticsEvent) => {
  if (analyticsEvent && window.digitalData) {
    window.digitalData.event = window.digitalData.event || [];
    window.digitalData.event.push(analyticsEvent);
  }
};

export const getAnalyticsSettingsValue = (printOption) => {
  const baseString = 'homepage: workspace dashboard: share quote: email: ';
  switch (printOption) {
  case PRINT_WITH_PRICE_DISCOUNT:
    return baseString + 'price and discounts';
  case PRINT_WITH_PRICE_ONLY:
    return baseString + 'price only';
  case PRINT_WITH_NO_PRICE:
    return baseString + 'no price or discounts';
  default:
    return '';
  }
};